<template>
  <v-container ref="barWrapper" fluid fill-height class="back" ma-0 pa-1 >
    <v-layout column fill-height  justify-start>
      <loading-circle
          :show="loader"
        />
      <v-toolbar color="secondary" dense>
        <v-toolbar-title>
          <span v-if="mode == 'create'" class="body-1 uppercase white--text">{{ $t('new event for') }} {{ data.name }}</span>
          <span v-else class="body-1 uppercase white--text">{{ $t('event') }} {{ data.users_name }}</span>
        </v-toolbar-title>

        <v-layout fill-height justify-end>
          <v-tooltip v-if="mode == 'create'" dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'createEvent'" v-if="mode == 'create'" icon flat slot="activator" @click="createEvent">
              <v-icon color="white">done</v-icon>
            </v-btn>
            <span>{{ $t('create') }}</span>
          </v-tooltip>

          <v-tooltip v-if="mode == 'edit'" dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'updateEvent'" v-if="mode == 'edit'" icon flat slot="activator" @click="updateEvent">
              <v-icon color="white">done</v-icon>
            </v-btn>
            <span>{{ $t('save') }}</span>
          </v-tooltip>
          
          <v-tooltip v-if="mode == 'show'" dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'editEvent'" v-if="mode == 'show'" icon flat slot="activator" @click="editEvent">
              <v-icon small color="white">edit</v-icon>
            </v-btn>
            <span>{{ $t('edit') }}</span>
          </v-tooltip>

          <v-tooltip v-if="mode != 'edit'" dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'emit-close'" v-if="mode != 'edit'" icon flat slot="activator" @click="$emit('close')">
              <v-icon color="white">close</v-icon>
            </v-btn>
            <span>{{ $t('close') }}</span>
          </v-tooltip>

          <v-tooltip v-if="mode == 'edit'" dark color="secondary" left>
            <v-btn :data-testid="$options.name + 'v-btn' + 'showEvent'" v-if="mode == 'edit'" icon flat slot="activator" @click="showEvent">
              <v-icon color="white">close</v-icon>
            </v-btn>
            <span>{{ $t('cancel') }}</span>
          </v-tooltip>
        </v-layout>
      </v-toolbar>

      <v-layout wrap>
        <v-flex v-for="(state, i) in getItems.state" :key="state + i + 'button'" v-if="eventState[state.id]" :class="i > 0 ? 'pl-1' : 'pl-0'">
          <v-btn :data-testid="$options.name + 'v-btn' + 'onStateChange-state'" small text block depressed
            :disabled="eventState[state.id].disabled"
            :class="eventState[state.id].disabled ? 'light' : 'dark'"
            :color="eventState[state.id].active ? 'primary' : 'secondary'"
            @click="() => onStateChange(state)"
          >{{ $t(state.id) }}</v-btn>
        </v-flex>
      </v-layout>

      <scroll-area>
        <template slot="body">
          <!-- TEMPLATE FOR CREATE  -->
          <v-layout shrink ref="modal_layout" wrap>
            <v-flex xs6 px-0 >
              <v-layout column fill-height justify-start>
                <v-flex v-for="(field, name) in getFields" :key="field + name" v-if="field.show == 'true'" px-1 pb-1>
                  <v-layout shrink v-if="field.type != 'json'" px-2>
                    <v-flex xs4 shrink px-0 pb-2>               
                      <v-text-field
                        :value="$t(field.name)"
                        light
                        outline
                        flat
                        readonly
                        disabled
                        class="backgrey"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="white"
                      >                  
                      </v-text-field>
                    </v-flex>

                    <v-flex xs8 shrink px-0 pb-2>
                      <v-text-field
                        v-if="field.place != 'head' && field.show == 'true' && (field.type == 'text' || field.type == 'integer' || field.type == 'timestamp'  || field.type == 'TIMESTAMP WITH TIME ZONE')"
                        :data-testid="$options.name + 'v-text-field' + field.name"
                        v-model="model.obj[field.name]"
                        light
                        outline
                        :readonly="field.readonly"
                        class="white"
                        persistent-hint
                        hide-details
                        :rows="1"
                        color="accent"
                      >
                      </v-text-field>

                      <v-select
                        v-if="!field.fields && field.show == 'true' && (field.type == 'select' || field.type == 'select_enum')"
                        v-model="model.obj[field.name]"
                        :data-testid="$options.name + '__' + field.type + '__select-field__' + field.name"
                        light
                        :readonly="field.readonly"
                        :disabled="field.readonly"
                        :items="getItems[field.cls]"
                        :item-text="field.type == 'select' ? 'name' : 'value'"
                        :item-value="field.type == 'select' ? '$id' : 'id'"
                        :rules="field.required ? [value => !!value || $t('field must be filled')] : []"
                        outline
                        hide-details
                        class="white"
                        background-color="backgrey"
                        :clearable="!field.readonly"
                      >
                        <template v-slot:item="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                        <template v-slot:selection="{ item, index }">
                            <span>{{ $t(field.type == 'select' ? item.name : item.value) }}</span>
                        </template>
                      </v-select>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <v-flex shrink v-for="(field, name) in getFields" :key="'boolean' + name" v-if="field.show == 'true' && field.type == 'boolean'" px-1>
                  <v-checkbox :data-testid="$options.name + 'v-checkbox' + field.name" small light color="secondary" v-model="model.obj[field.name]">
                    <template v-slot:label>
                      <span class="black--text" v-if="model.fields[field.name] && model.fields[field.name].required">{{$t(field.name) + ' *'}}</span>
                      <span class="black--text" v-else>{{$t(field.name)}}</span>
                    </template>
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs6 px-0 >
              <file-list
                :files="getFiles"
                :data="getData"
                :editable="false"
                :showDescription="false"
                @upload="(payload) => onFileAdd(payload)"
                @delete="(payload) => onFileDelete(payload)"
              />
            </v-flex>
          </v-layout>

          <v-flex v-for="(field, name) in getFields" :key="field + name + 'json'" v-if="field.type == 'json'" :style="'position: relative;'">
            <v-flex v-if="field.type == 'json' && model.obj[field.name]" shrink px-2>
              <span v-if="field.type == 'json' && model.obj[field.name]" :class="!field.readonly ? 'subheading primary--text' : 'subheading'">{{$t(field.name)}}</span>
            </v-flex>
            <vue-editor
              v-if="field.type == 'json' && model.obj[field.name]" 
              :id="field.name"
              :disabled = "field.readonly"
              v-model="model.obj[field.name].data"
              :customModules="customModulesForEditor"
              :editor-toolbar="customToolbar"
              :editorOptions="editorSettings"
              class="editor"
              @ready="(payload) => prepareEditor(payload, field.name)"
            >
            </vue-editor>
          </v-flex>
        </template>
      </scroll-area>
    </v-layout>

    <v-dialog v-model="dialog.upload.show" max-width="50%" v-if="dialog.upload.show">
      <form-file-import
        :newFiles="dialog.upload.files"
        :edit="filesEdit"
        :files="filesEdit ? getFiles : []"
        :activeObj="getData"
        @update="() => onUpdate()"
        @close="onFileImportClose()"
        @delete="(payload) => onFileDelete(payload)"
      />
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue'
import loadingCircle from '@/nms/components/partials/loader.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import fileList from '@/nms/components/partials/file-list.vue'
import uuidv4 from 'uuid/v4'
import { mapGetters } from 'vuex'
import FormFileImport from '@/nms/pages/forms/form-file-import.vue'
import { VueEditor } from 'vue2-editor'
import ImageResize from 'quill-image-resize-vue'
import { ImageDrop } from 'quill-image-drop-module'

// Типы
interface EventData {
  $id?: string
  cls?: string
  name?: string
  state?: string
  users_name?: string
  _cmdb_?: any
  [key: string]: any
}

interface ModelField {
  value?: any
  type?: string
  readonly?: boolean
  show?: boolean
  required?: string
  [key: string]: any
}

interface ModelFields {
  [key: string]: ModelField
}

interface ModelItems {
  [key: string]: any
}

interface ModelObj {
  [key: string]: any
}

interface Model {
  fields: ModelFields
  items: ModelItems
  obj: ModelObj
}

interface EventStateItem {
  active: boolean
  disabled: boolean
}

interface EventState {
  new_event: EventStateItem
  read_event: EventStateItem
  archived_event: EventStateItem
  deleted_event: EventStateItem
}

interface DialogState {
  state: {
    show: boolean
    state: string | null
  }
  upload: {
    show: boolean
    files: any[]
  }
}

interface FileItem {
  id?: string
  name?: string
  [key: string]: any
}

interface EditorModule {
  alias: string
  module: any
}

interface CustomToolbarItem {
  [key: string]: any
}

export default Vue.extend({
  name: 'EVENT_MODAL',

  components: {
    loadingCircle,
    scrollArea,
    fileList,
    VueEditor,
    FormFileImport
  },

  props: {
    data: {
      type: Object as () => EventData,
      default: () => ({})
    },
    parentActions: {
      type: Object as () => Record<string, any>,
      default: () => ({})
    },
  },

  data(): {
    loader: boolean
    mode: string
    eventData: EventData | null
    meta: Record<string, any>
    eventState: EventState
    dialog: DialogState
    model: Model
    files: any[]
    filesEdit: boolean
    customModulesForEditor: EditorModule[]
    customToolbar: CustomToolbarItem[]
    editorSettings: Record<string, any>
  } {
    return {
      loader: false,
      mode: 'show',
      eventData: null,
      meta: {},
      eventState: {
        new_event: { active: false, disabled: true },
        read_event: { active: false, disabled: true },
        archived_event: { active: false, disabled: true },
        deleted_event: { active: false, disabled: true },
      },
      dialog: {
        state: { show: false, state: null },
        upload: { show: false, files: [] },
      },
      model: { fields: {}, items: {}, obj: {} },
      files: [],
      filesEdit: false,
      customModulesForEditor: [
        { alias: 'imageDrop', module: ImageDrop },
        { alias: 'imageResize', module: ImageResize }
      ],
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }],
        [{ align: [] }],
        ['clean']
      ],
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {}
        }
      }
    }
  },

  computed: {
    getData(): EventData | null {
      return this.eventData
    },
    getFields(): ModelFields {
      return this.model.fields
    },
    getItems(): ModelItems {
      return this.model.items
    },
    getFiles(): any[] {
      return this.files
    },
    ...mapGetters(['getCurrentUser'])
  },

  watch: {
    data: {
      handler(newVal: EventData): void {
        console.log('WATCH', this.$options.name, 'data', newVal)
        if (newVal) {
          this.setup()
        }
      },
      deep: true
    },
  },

  created(): void {
    console.log('WATCH', this.$options.name, 'created', 'data', this.data)
    if (!this.eventData) {
      this.eventData = this.$merge({}, this.data)
    }
    this.setup()
  },

  updated(): void {
    this.prepareEditor()
  },

  methods: {
    async setup(): Promise<void> {
      await this.checkMode()
      this.reset()
      console.log(this.$options.name, 'setup', 'data', this.eventData)
      await this.loadMeta(this.$options.name)
      this.loadFiles()
    },

    async checkMode(): Promise<void> {
      if (!this.eventData?.cls || this.eventData.cls !== 'event') {
        this.mode = 'create'
      }
    },

    async loadMeta(caller: string): Promise<void> {
      try {
        console.log(this.$options.name, 'loadMeta!!!!')
        // this.meta = await this.$bridge.getMeta('event')
        this.meta = await this.$loadMeta('event')
        // this.meta = await this.$loadMeta(this.getData)
        console.log('this.$options.name', 'loadMeta', 'caller', caller, 'this.meta', this.meta)
        if (this.meta) {
          this.model = await this.$prepareMeta(this.meta, this.$options.name)
          await this.prepareData()
        }
      } catch (error) {
        console.error('CATCH', this.$options.name, 'loadMeta', 'error', error)
      }
    },

    async prepareData(): Promise<void> {
      try {
        const fields = Object.keys(this.model.fields)
        
        for (const name of fields) {
          // Create mode
          if (this.mode === 'create') {
            this.$set(this.model.fields[name], 'readonly', false)
            
            if (name === 'object_id') {
              this.$set(this.model.fields[name], 'value', this.eventData?.$id)
              this.$set(this.model.obj, name, this.eventData?.$id)
              this.$set(this.model.fields[name], 'readonly', true)
            }
            
            if (name === 'name') {
              const uid = uuidv4()
              this.$set(this.model.fields[name], 'value', `event_${uid}`)
              this.$set(this.model.obj, name, `event_${uid}`)
            }
            
            if (name === 'state') {
              this.$set(this.model.fields[name], 'value', 'new_event')
              this.$set(this.model.obj, name, 'new_event')
              this.$set(this.model.fields[name], 'show', false)
              this.$set(this.model.fields[name], 'readonly', true)
              this.eventState.new_event.active = true
              this.eventState.new_event.disabled = false
            }
            
            if (name === 'last_update_user') {
              this.$set(this.model.fields[name], 'value', this.getCurrentUser?.login)
              this.$set(this.model.obj, name, this.getCurrentUser?.login)
              this.$set(this.model.fields[name], 'show', false)
              this.$set(this.model.fields[name], 'readonly', true)
            }
            
            if (this.model.fields[name].type === 'json') {
              this.$set(this.model.obj, name, {})
              this.$set(this.model.obj[name], 'data', '')
            }
            
            if (this.model.fields[name].type === 'TIMESTAMP WITH TIME ZONE') {
              this.$set(this.model.fields[name], 'value', (this as any).moment().format('DD.MM.YYYY HH:mm'))
              this.$set(this.model.obj, name, (this as any).moment())
              this.$set(this.model.fields[name], 'readonly', true)
              this.$set(this.model.fields[name], 'show', false)
            }
            
            if (name === 'template') {
              this.$set(this.model.fields[name], 'value', 'maintenance')
              this.$set(this.model.obj, name, 'maintenance')
              this.$set(this.model.fields[name], 'show', false)
              this.$set(this.model.fields[name], 'readonly', true)
            }
          }
          
          // Edit mode
          if (this.mode === 'edit') {
            this.$set(this.model.fields[name], 'value', this.eventData?.[name])
            this.$set(this.model.obj, name, this.eventData?.[name])
            
            if (this.model.fields[name].type === 'timestamp' || this.model.fields[name].type === 'TIMESTAMP WITH TIME ZONE') {
              this.$set(this.model.fields[name], 'value', (this as any).moment(this.eventData?.[name]).format('DD.MM.YYYY HH:mm'))
              this.$set(this.model.obj, name, this.eventData?.[name])
            }
            
            if (name === 'last_update_user') {
              this.$set(this.model.obj, 'last_update_user', this.getCurrentUser?.login)
            }
            
            if (name === 'last_update_date') {
              this.$set(this.model.obj, 'last_update_date', (this as any).moment())
            }
            
            this.handleStateInEditMode(name)
            
            if (name === 'template') {
              this.$set(this.model.fields[name], 'value', 'maintenance')
              this.$set(this.model.obj, name, 'maintenance')
              this.$set(this.model.fields[name], 'show', false)
              this.$set(this.model.fields[name], 'readonly', true)
            }
          }
          
          // Show mode
          if (this.mode === 'show') {
            this.$set(this.model.fields[name], 'value', this.eventData?.[name])
            this.$set(this.model.fields[name], 'readonly', true)
            this.$set(this.model.obj, name, this.eventData?.[name])
            
            if (this.model.fields[name].type === 'timestamp' || this.model.fields[name].type === 'TIMESTAMP WITH TIME ZONE') {
              this.$set(this.model.fields[name], 'value', (this as any).moment(this.eventData?.[name]).format('DD.MM.YYYY HH:mm'))
              this.$set(this.model.obj, name, this.eventData?.[name])
            }
            
            if (name === 'last_update_user') {
              this.$set(this.model.obj, 'last_update_user', this.getCurrentUser?.login)
            }
            
            if (name === 'last_update_date') {
              this.$set(this.model.obj, 'last_update_date', (this as any).moment())
            }
            
            this.handleStateInShowMode(name)
            
            if (name === 'template') {
              this.$set(this.model.fields[name], 'value', 'maintenance')
              this.$set(this.model.obj, name, 'maintenance')
              this.$set(this.model.fields[name], 'show', false)
              this.$set(this.model.fields[name], 'readonly', true)
            }
          }
        }
        
        console.log(this.$options.name, 'prepareData', 'this.model.fields', this.model.fields)
        console.log(this.$options.name, 'prepareData', 'this.model.obj', this.model.obj)
        console.log(this.$options.name, 'prepareData', 'this.model.items', this.model.items)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'prepareData', 'error', err)
      }
    },

    handleStateInEditMode(name: string): void {
      if (name === 'state') {
        this.$set(this.model.fields[name], 'readonly', false)
        this.$set(this.model.fields[name], 'show', false)
        
        const stateValue = this.eventData?.[name]
        if (stateValue) {
          this.$set(this.eventState[stateValue as keyof EventState], 'active', true)
          this.$set(this.eventState[stateValue as keyof EventState], 'disabled', false)
          
          if (stateValue === 'read_event') {
            this.$set(this.eventState.archived_event, 'active', false)
            this.$set(this.eventState.archived_event, 'disabled', false)
            this.$set(this.eventState.deleted_event, 'active', false)
            this.$set(this.eventState.deleted_event, 'disabled', false)
          }
          if (stateValue === 'archived_event') {
            this.$set(this.eventState.read_event, 'active', false)
            this.$set(this.eventState.read_event, 'disabled', false)
            this.$set(this.eventState.deleted_event, 'active', false)
            this.$set(this.eventState.deleted_event, 'disabled', false)
          }
          if (stateValue === 'deleted_event') {
            this.$set(this.eventState.read_event, 'active', false)
            this.$set(this.eventState.read_event, 'disabled', false)
            this.$set(this.eventState.archived_event, 'active', false)
            this.$set(this.eventState.archived_event, 'disabled', false)
          }
        }
      }
      
      if (name === 'state' && this.eventData?.[name] === 'new_event') {
        this.$set(this.model.obj, name, 'read_event')
        this.$set(this.model.obj, 'last_update_date', (this as any).moment())
        this.$set(this.model.obj, 'last_update_user', this.getCurrentUser?.login)
        this.$set(this.model.fields.last_update_date, 'value', (this as any).moment().format('DD.MM.YYYY HH:mm'))
        this.updateEvent(['state', 'last_update_date', 'last_update_user'])
      }
    },

    handleStateInShowMode(name: string): void {
      if (name === 'state' && this.eventData?.[name]) {
        if (this.eventData[name] === 'new_event') {
          this.$set(this.model.fields[name], 'show', false)
          this.$set(this.model.obj, name, 'read_event')
          this.$set(this.model.obj, 'last_update_date', (this as any).moment())
          this.$set(this.model.obj, 'last_update_user', this.getCurrentUser?.login)
          this.$set(this.model.fields.last_update_date, 'value', (this as any).moment().format('DD.MM.YYYY HH:mm'))
          this.updateEvent(['state', 'last_update_date', 'last_update_user'])
        }
        this.$set(this.eventState[this.eventData[name] as keyof EventState], 'active', true)
        this.$set(this.eventState[this.eventData[name] as keyof EventState], 'disabled', false)
      }
    },

    prepareEditor(e?: any, id?: string): void {
      const wrapperHeight = (this.$refs['barWrapper'] as HTMLElement)?.clientHeight
      const layoutHeight = (this.$refs['modal_layout'] as HTMLElement)?.clientHeight
      
      const byId = document.getElementById(id || '')
      if (byId) {
        const editor = byId.querySelector('.ql-editor') as HTMLElement
        if (editor) {
          editor.style['max-height'] = '120px'
          editor.style['min-height'] = 'auto'
          editor.style['font-size'] = '12px'
          editor.style['line-height'] = '1'
        }
      }
    },

    async loadFiles(): Promise<void> {
      try {
        if (this.eventData?.cls !== 'event') return
        this.setLoader('loadFiles', true)
        this.files = await this.$loadFiles(this.eventData.$id)
        console.log(this.$options.name, 'loadFiles', 'this.files', this.files)
        this.setLoader('loadFiles', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadFiles', err)
        this.setLoader('loadFiles', false)
      }
    },

    onFileAdd(payload: any): void {
      console.log(this.$options.name, 'onFileAdd', 'payload', payload)
      Object.keys(payload).forEach((index: string) => {
        this.dialog.upload.files.push(payload[index])
      })
      this.dialog.upload.show = true
    },

    async onFileDelete(id: string): Promise<void> {
      this.files.forEach((file: any, index: number) => {
        if (file.id === id) {
          this.files.splice(index, 1)
        }
      })
      try {
        const d = await this.$bridge.deleteDocument(id)
        if (d) {
          await this.updateEvent(['last_update_date', 'last_update_user'])
          this.loadFiles()
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'onFileDelete', err)
      }
    },

    onStateChange(state: { id: string }): void {
      this.$set(this.dialog.state, 'state', state.id)
      this.$dialog.confirm({
        text: `Вы действительно хотите поменять статус события ${this.eventData?.users_name}?`,
        title: 'Изменение статуса',
        actions: {
          false: {
            text: 'Отмена',
            handle: async () => {
              try {
                this.$set(this.dialog.state, 'state', null)
              } catch (err) {
                console.error('CATCH', this.$options.name, 'onStateChange', err)
                this.$errorHandler(err)
              }
            }
          },
          true: {
            color: 'red',
            text: 'Да',
            handle: async () => {
              try {
                this.$set(this.model.obj, 'state', this.dialog.state.state)
                this.$set(this.model.obj, 'last_update_date', (this as any).moment())
                this.$set(this.model.obj, 'last_update_user', this.getCurrentUser?.login)
                await this.updateEvent()
              } catch (err) {
                console.error('CATCH', this.$options.name, 'onStateChange', err)
                this.$errorHandler(err)
              }
            }
          }
        }
      })
    },

    async changeState(): Promise<void> {
      this.$set(this.model.obj, 'state', this.dialog.state.state)
      this.$set(this.model.obj, 'last_update_date', (this as any).moment())
      this.$set(this.model.obj, 'last_update_user', this.getCurrentUser?.login)
      await this.updateEvent()
    },

    async createEvent(): Promise<void> {
      console.log(this.$options.name, 'createEvent', 'start')
      const data$: Record<string, any> = { type: 'event' }
      const fields = Object.keys(this.model.obj)
      
      fields.forEach(field => {
        data$[field] = this.model.obj[field]
      })
      
      console.log(this.$options.name, 'createEvent', 'data$', data$)
      
      let validate = true
      Object.keys(this.model.fields).forEach(field => {
        const f = this.model.fields[field]
        if (f.required && f.required != 'false' && f.show && f.show != 'false') {
          if (!this.model.obj[field]) {
            console.log(this.$options.name, 'changeState field', field)
            validate = false
          }
        }
      })
      
      if (!validate) {
        console.log(this.$options.name, 'changeState validate', validate)
        this.$snotify.warning('Обязательные поля не заполнены!', {
          timeout: 2000,
          showProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
        })
        return
      }
      
      try {
        const events = await this.$bridge.getByPath('/events')
        const event = await events.createChild('event', data$)
        
        if (event) {
          console.log(this.$options.name, 'createEvent', 'event', event)
          if (this.files.length) {
            const formData = new FormData()
            this.files.forEach((file: any) => {
              formData.append('files', file)
            })
            const updatedEvent = await event.update(formData)
            if (updatedEvent) {
              console.log(this.$options.name, 'createEvent', 'updatedEvent', updatedEvent)
            }
          }
          await this.parentActions.setup()
          this.$emit('close')
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'createEvent', err)
        this.$errorHandler(err)
      }
    },

    async updateEvent(fields_?: string[]): Promise<void> {
      console.log(this.$options.name, 'updateEvent', 'start')
      console.log(this.$options.name, 'updateEvent', 'fields_', fields_)
      
      if (this.eventData?.cls !== 'event') return
      
      const data$: Record<string, any> = {}
      
      if (Array.isArray(fields_) && fields_.length) {
        fields_.forEach(field_ => {
          data$[field_] = this.model.obj[field_]
        })
      } else {
        const fields = Object.keys(this.model.obj)
        fields.forEach(field => {
          data$[field] = this.model.obj[field]
        })
        
        let validate = true
        Object.keys(this.model.fields).forEach(field => {
          const f = this.model.fields[field]
          if (f.required && f.required !== 'false' && f.show && f.show !== 'false') {
            if (!this.model.obj[field]) {
              console.log(this.$options.name, 'updateEvent field', field)
              validate = false
            }
          }
        })
        
        if (!validate) {
          console.log(this.$options.name, 'updateEvent validate', validate)
          this.$snotify.warning('Обязательные поля не заполнены!', {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
          })
          return
        }
      }
      
      console.log(this.$options.name, 'updateEvent', 'data$', data$)
      
      try {
        const event = this.eventData._cmdb_ 
          ? this.eventData 
          : await this.$bridge.getObjectById(this.eventData.$id)
        
        let updatedEvent = await event.update(data$)
        
        if (updatedEvent) {
          let u = updatedEvent
          if (this.files.length) {
            const formData = new FormData()
            this.files.forEach((file: any) => {
              formData.append('files', file)
            })
            u = await updatedEvent.update(formData)
          }
          await this.parentActions.setup()
          this.eventData = u
          this.showEvent()
          console.log(this.$options.name, 'updateEvent', 'updatedEvent', updatedEvent)
        }
      } catch (err) {
        console.error('CATCH', this.$options.name, 'updateEvent', err)
        this.$errorHandler(err)
      }
    },

    async editEvent(): Promise<void> {
      this.mode = 'edit'
      this.setup()
    },

    async showEvent(): Promise<void> {
      this.mode = 'show'
      this.setup()
    },

    onEditorChange(delta: any, oldDelta: any, source: string): void {
      console.log(this.$options.name, 'onEditorChange', 'delta', delta)
      console.log(this.$options.name, 'onEditorChange', 'oldDelta', oldDelta)
      console.log(this.$options.name, 'onEditorChange', 'source', source)
    },

    onFileImportClose(): void {
      this.dialog.upload.show = false
      this.filesEdit = false
      this.dialog.upload.files = []
    },

    onUpdate(): void {
      setTimeout(() => this.loadFiles(), 1000)
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    reset(): void {
      this.loader = false
      this.meta = {}
      this.model = {
        fields: {},
        items: {},
        obj: {}
      }
      this.eventState = {
        new_event: { active: false, disabled: true },
        read_event: { active: false, disabled: true },
        archived_event: { active: false, disabled: true },
        deleted_event: { active: false, disabled: true },
      }
      this.dialog = {
        state: { show: false, state: null },
        upload: { show: false, files: [] },
      }
      this.files = []
    }
  }
})
</script>

<style scoped>
</style>
